import React, { Dispatch, useEffect } from "react";
import Select from "react-select";
import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "../../CommonComponents/Common";
import {
  getHealthCheckServiceAction,
  saveCallSettingsAction,
} from "../../ProjectSection/CallSettings/Store/callSetting.action";
import BaseButton from "../../Common/Buttons/BaseButton";
import { Box, Typography, IconButton, Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import { ReactComponent as WarningIcon } from "../../../../assets/icons/warning.svg";
import { ReactComponent as CancelIcon } from "../../../../assets/icons/cancel.svg";
import { ReactComponent as SuccessIcon } from "../../../../assets/icons/success.svg";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";

const HealthCheck = ({ loading }) => {
  const history = useHistory();
  const dispatch: Dispatch<any> = useDispatch();
  const reducer: any = useSelector((state) => state);
  const { projectId } = useParams<{ projectId: string }>();
  const VODEX_OWNED_GATEWAYS = ["vodex_twilio", "vodex_voice", "vodex_plivo"];
  const {
    AccountReducer: { constantData },
    ProjectReducer: { selectedProject },
    CallSettingReducer: { callSettings },
  } = reducer;
  const [toggle, setToggle] = useState(false);
  const [stableHealthStatus, setStableHealthStatus] = useState(true);
  const [healthCheckStatus, setHealthCheckStatus] = useState<any>([]);
  const [state, setState] = useState({
    callerIdNumber: "",
    callTransferNumber: "",
    disconnectedTime: "",
    asrEngine: "",
    gateway: "",
    responseFormat: selectedProject?.botPlatform?.includes("recording")
      ? "recording"
      : "TTS",
    voice: "",
    languageCode: "",
    interrupt: 0,
    voiceMailDetection: true,
    silentThreshold: "3",
    temperature: "0.2",
    pauseBetweenSentence: "0",
    transferWebhook: "",
    checkUser: false,
    checkDnc: false,
    checkDnd: false,
    model: "001",
    transferGateway: "",
    ringingDisconnect: "",
    transferType: "bridge_call",
    insightsWebhook: "",
    stream: false,
  });
  const [healtCheckState, setHealthCheckState] = useState({
    asrVal: 0,
    modelVal: 0,
    ttsVal: 0,
  });
  const [showValues, setShowValues] = useState({
    asrShow: false,
    voiceShow: false,
    modelShow: false,
  });
  const [isExpand, setIsExpand] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [allServicesWorking, setAllServicesWorking] = useState(false);
  const { asrShow, voiceShow, modelShow } = showValues;
  const { asrVal, modelVal, ttsVal } = healtCheckState;
  const [isLoading, setIsLoading] = useState(false);

  const [constantArray, setConstantArray] = useState({
    asrEngines: [],
    modelOptions: [],
  });

  const { asrEngines, modelOptions } = constantArray;

  const {
    callTransferNumber,
    callerIdNumber,
    disconnectedTime,
    asrEngine,
    gateway,
    responseFormat,
    voice,
    languageCode,
    interrupt,
    voiceMailDetection,
    silentThreshold,
    temperature,
    pauseBetweenSentence,
    transferWebhook,
    checkUser,
    checkDnc,
    checkDnd,
    model,
    ringingDisconnect,
    transferGateway,
    insightsWebhook,
    transferType,
    stream,
  } = state;

  useEffect(() => {
    if (!isEmpty(callSettings)) {
      let localCallSetting = callSettings;
      if (typeof localCallSetting?.interrupt === "boolean") {
        if (localCallSetting?.interrupt === true) {
          localCallSetting["interrupt"] = "1";
        } else {
          localCallSetting["interrupt"] = "0";
        }
      }
      setState((prev) => ({
        ...prev,
        ...localCallSetting,
      }));
    }
  }, [callSettings]);

  useEffect(() => {
    healthCheck();

    const intervalId = setInterval(() => {
      healthCheck();
    }, 15000);

    return () => clearInterval(intervalId);
  }, []);

  const healthCheck = async () => {
    setIsLoading(true);
    const res: any = await dispatch(getHealthCheckServiceAction());
    setHealthCheckStatus(res?.data);
    setIsLoading(false);
  };

  useEffect(() => {
    let voicesCopy = constantData?.voices;
    voicesCopy = voicesCopy?.map((voic) => {
      return {
        ...voic,
        isDisabled: voic.disabled,
      };
    });
    setConstantArray({ ...constantData, voices: voicesCopy });
  }, [constantData]);

  useEffect(() => {
    if (isExpand) {
      const timer = setTimeout(() => {
        setIsContentVisible(true);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      setIsContentVisible(false);
    }
  }, [isExpand]);

  const saveCallSettings = async (nav) => {
    setIsLoading(true);
    let sendObj: any = {
      projectId: projectId,
      callTransferNumber,
      callerIdNumber,
      disconnectedTime,
      gateway,
      asrEngine,
      responseFormat,
      languageCode,
      interrupt,
      voiceMailDetection,
      silentThreshold,
      temperature,
      pauseBetweenSentence,
      transferWebhook,
      checkUser,
      checkDnc,
      checkDnd,
      model,
      transferGateway,
      ringingDisconnect,
      insightsWebhook,
      transferType: VODEX_OWNED_GATEWAYS.includes(gateway)
        ? "bridge_call"
        : transferType,
      stream,
    };

    if (sendObj?.interrupt === "true" || sendObj.interrupt === true) {
      sendObj["interrupt"] = "1";
    }
    if (sendObj?.interrupt === "false" || sendObj.interrupt === false) {
      sendObj["interrupt"] = "0";
    }

    await dispatch(saveCallSettingsAction(sendObj));
    // await dispatch(getCallSettingAction(projectId));
    await dispatch(getHealthCheckServiceAction());
    close();
    if (nav) {
      history.push(`/account/project/${projectId}/call-settings`);
    }
    setIsLoading(false);
  };

  const healthCheckfunction = () => {
    if (!Array.isArray(healthCheckStatus))
      return { modelStatus: 0, asrStatus: 0, ttsStatus: 0 };
    // Getting Value of Current Selected ASR (either 1, 0 or -1)
    let asrStatus;
    if (asrEngine === "google") {
      asrStatus = 1;
    } else {
      const selectedAsrArray = healthCheckStatus?.find(
        (item) => item?.type === "asr" && item?.values?.includes(asrEngine)
      );
      asrStatus = selectedAsrArray?.value;
    }
    // Getting Value of Current Selected Model (either 1, 0 or -1)
    const selectedModelValue = healthCheckStatus?.find(
      (item) => item?.type === "model" && item?.values?.includes(model)
    );
    const modelStatus = selectedModelValue?.value;

    // Get the Value of Selected Voice
    let ttsStatus;
    const typeTts = healthCheckStatus?.filter((v) => v?.type === "tts");
    const selectedVoiceProvider = callSettings?.voiceData?.provider;

    const engineValue =
      typeTts
        ?.filter(
          (engine: any) =>
            (selectedVoiceProvider === "gg" && engine?.name === "Google") ||
            (selectedVoiceProvider === "11" &&
              engine?.name === "Eleven Labs") ||
            (selectedVoiceProvider === "ht" && engine?.name === "Play HT") ||
            (selectedVoiceProvider === "ms" && engine?.name === "Azure")
        )
        ?.map((engine) => engine?.value)[0] || null;

    ttsStatus = engineValue;

    return { modelStatus, asrStatus, ttsStatus };
  };

  useEffect(() => {
    const { asrStatus, ttsStatus, modelStatus } = healthCheckfunction();
    setShowValues({
      asrShow: asrStatus === 1,
      voiceShow: ttsStatus === 1,
      modelShow: modelStatus === 1,
    });
    setHealthCheckState((prev) => ({
      ...prev,
      asrVal: asrStatus,
      modelVal: modelStatus,
      ttsVal: ttsStatus,
    }));
  }, [healthCheckStatus, callSettings, voice, asrEngine, model]);

  useEffect(() => {
    if (!stableHealthStatus) {
      if (!loading) {
        setIsExpand(true);
      }
    } else {
      setIsExpand(false);
    }
  }, [stableHealthStatus, loading]);

  useEffect(() => {
    const currentStatus = asrVal === 1 && modelVal === 1 && ttsVal === 1;
    setAllServicesWorking(currentStatus);
    setStableHealthStatus(currentStatus);
  }, [asrVal, modelVal, ttsVal]);

  const getErrorString = (asrValue, modelValue, ttsValue) => {
    const errors: string[] = [];

    if (asrValue !== 1) {
      errors.push("ASR");
    }
    if (modelValue !== 1) {
      errors.push("Model");
    }
    if (ttsValue !== 1) {
      errors.push("Voice");
    }
    return errors.length > 0 ? errors.join(", ") : null;
  };

  // Disabling ASR in Select
  const disableValues = (option) => {
    if (option?.value === "google") {
      return false;
    }
    const check = healthCheckStatus?.filter(
      (st) => st?.type === "asr" && st?.value === 1
    );
    const isWorking = check?.some((st) => st.values?.includes(option.value));
    return !isWorking;
  };

  // Disabling Model Value
  const disableModelValues = (option) => {
    const check = healthCheckStatus?.filter(
      (st) => st?.type === "model" && st?.value === 1
    );
    const isWorking = check?.some((st) => st?.values?.includes(option.value));
    return !isWorking;
  };

  // Disabling TTS values
  const disabledTtsValues = (voice) => {
    const ttsHealth = healthCheckStatus.filter((h) => h.type === "tts");

    for (let health of ttsHealth) {
      const hasEngine = voice.hasOwnProperty("engine");
      const isValueIncluded = hasEngine
        ? health.values.includes(voice.engine)
        : false;
      if (!hasEngine && health.value === 1) {
        return false;
      }
      if (isValueIncluded && health.value !== 1) {
        return true;
      }
    }
    return false;
  };

  const handleClick = () => setToggle(true);
  const close = () => setToggle(false);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          minHeight: 150,
          overflow: "hidden",
          transition: "all 0.3s ease-in-out",
          position: "absolute",
          justifyContent: isExpand ? "flex-start" : "center",
          width: isExpand ? 450 : 20,
        }}
        className="health-check-card-cont"
      >
        <Box className="flex-only">
          <Box className="flex-align-center">
            <IconButton
              onClick={() => setIsExpand(!isExpand)}
              sx={{
                marginLeft: 1,
                color: "white",
                width: 4,
              }}
              title={
                !isExpand
                  ? "Click to view the status of ASR, Model, and Voice settings."
                  : ""
              }
            >
              {isExpand ? (
                <ArrowForwardIosIcon sx={{ height: 14, width: 14 }} />
              ) : (
                <ArrowBackIosIcon sx={{ height: 14, width: 14 }} />
              )}
            </IconButton>
          </Box>
          {isExpand && isContentVisible && (
            <Box className="ml-2">
              <Box className="status-card">
                <Box className="status-card-inner">
                  <Box>
                    {allServicesWorking ? <SuccessIcon /> : <CancelIcon />}
                  </Box>
                  <Box className="flex-column">
                    <Typography
                      color="white"
                      gutterBottom
                      sx={{
                        fontSize: 20,
                        fontWeight: 600,
                      }}
                    >
                      {allServicesWorking ? "Health Check" : "Oops!"}
                    </Typography>
                    <Typography color="white" className="font-16-500">
                      {allServicesWorking
                        ? " Your ASR, Voice, and Model are working well."
                        : `Your ${getErrorString(
                            asrVal,
                            modelVal,
                            ttsVal
                          )} is not working. Fix with alternative.`}
                    </Typography>
                  </Box>
                </Box>
                {!allServicesWorking && (
                  <Box className="options-buttton-container">
                    <BaseButton
                      title="Check Availability"
                      variant="contained"
                      handleClick={handleClick}
                      styles={{
                        color: "white",
                        backgroundColor: "#202020",
                        borderColor: "#2F353E",
                        fontSize: 16,
                        "&:hover": {
                          backgroundColor: "#202020",
                        },
                      }}
                    />
                  </Box>
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>

      {toggle && (
        <CommonModal
          show={toggle}
          toggle={close}
          heading={
            <Box>
              <Box className="flex-align-center gap-1 mb-1">
                <WarningIcon />
                <Typography className="font-20-grey">Fix Issues</Typography>
              </Box>
              <Typography className="font-14-lightgrey">
                Few features are not working currently. Fix it before running
                campaign.
              </Typography>
            </Box>
          }
          body={
            <Box>
              {!modelShow && (
                <Box>
                  <Typography className="font-14-grey mb-2">
                    Model <span className="fix-required-star">*</span>
                  </Typography>
                  <Select
                    styles={commonStyles.commonSelectStyle(modelVal)}
                    maxMenuHeight={160}
                    className="basic-single"
                    classNamePrefix="select"
                    value={modelOptions?.find(
                      (name: any) => name.value === model
                    )}
                    isDisabled={false}
                    isOptionDisabled={disableModelValues}
                    isSearchable={true}
                    options={modelOptions}
                    getOptionLabel={(e: any) => e.name}
                    onChange={async (e) => {
                      setState((prev) => ({
                        ...prev,
                        model: e.value,
                      }));
                    }}
                    placeholder="Select Model"
                  />
                  {modelVal !== 1 && (
                    <Typography
                      component="p"
                      className="fix-required-star py-2"
                    >
                      Currently this selected Model is not working. Try with
                      other Model
                    </Typography>
                  )}
                </Box>
              )}

              {/* {!voiceShow && (
                <Box>
                  <Typography {...styles.title}>
                    Voice <span className="fix-required-star">*</span>
                  </Typography>

                  <Select
                    styles={selectStyle(ttsVal)}
                    maxMenuHeight={160}
                    className="basic-single"
                    classNamePrefix="select"
                    value={voices?.find((name: any) => name.value === voice)}
                    isOptionDisabled={(e: any) => disabledTtsValues(e)}
                    isDisabled={false}
                    isSearchable={true}
                    options={voices}
                    getOptionLabel={(e: any) => e.name}
                    onChange={async (e) => {
                      setState((prev) => ({
                        ...prev,
                        voice: e.value,
                      }));
                    }}
                    placeholder="Select Voice"
                  />
                </Box>
              )} */}

              {ttsVal === 1 && (
                <Box>
                  <Typography className="font-14-grey mb-2">
                    Voice <span className="fix-required-star">*</span>
                  </Typography>

                  <Typography component="p" className="fix-required-star">
                    Currently this selected voice is not working. Try with other
                    voice.
                  </Typography>
                  <Button
                    sx={{
                      ...commonStyles.clearButton,
                      marginTop: 0.6,
                      marginBottom: 2.5,
                    }}
                    onClick={() => saveCallSettings(true)}
                  >
                    {isLoading
                      ? "Redirecting..."
                      : "Click here to Select Voice"}
                  </Button>
                </Box>
              )}

              {!asrShow && (
                <Box>
                  <Typography className="font-14-grey mb-2">
                    ASR <span className="fix-required-star">*</span>
                  </Typography>

                  <Select
                    styles={commonStyles.commonSelectStyle(asrVal)}
                    maxMenuHeight={180}
                    className="basic-single"
                    classNamePrefix="select"
                    value={asrEngines?.find(
                      (name: any) => name.value === asrEngine
                    )}
                    isDisabled={false}
                    isSearchable={true}
                    options={asrEngines}
                    getOptionLabel={(e: any) => e.name}
                    isOptionDisabled={disableValues}
                    onChange={async (e) => {
                      setState((prev) => ({
                        ...prev,
                        asrEngine: e.value,
                      }));
                    }}
                    placeholder="Select ASR"
                  />
                  {asrVal !== 1 && (
                    <Typography
                      component="p"
                      className="fix-required-star py-2"
                    >
                      Currently this selected ASR is not working. Try with other
                      ASR.
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          }
          size={700}
          handleSave={() => saveCallSettings(false)}
          spin={isLoading}
        />
      )}
    </>
  );
};

export default HealthCheck;
